import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import ProfileSettingsComponent from "../../Component/ProfileSettings/ProfileSettingsComponent";

const mdTheme = createTheme();

function ProfileSettings() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <div className='sidebarsetting' >
          <Appbar mainpage="Home" subpage="Profile Settings" />
        </div>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            minHeight: "100vh",
            overflow: "auto",
            marginLeft: { xs: 0, sm: "64px", md: "280px" }, // Account for fixed sidebar
            paddingTop: { xs: "80px", sm: "80px", md: "80px" }, // Account for fixed header
            transition: "margin-left 0.3s ease",
            p: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <ProfileSettingsComponent />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default ProfileSettings; 